// Copyright (c) StrangeBee 2024

import Details from '@Molecules/Details/Details';
import React from 'react';
import { ReactNode } from 'react';
import { ReactElement } from 'react';

import './ResultCard.scss';

interface ResultCardProps {
    title?: ReactNode;
    date?: ReactNode;
    subtitle?: ReactNode;
    children?: ReactNode;
    data?: any;
    extract?: any;
}

export const ResultCard = ({ data, extract }: ResultCardProps): ReactElement => {
    return (
        <div className="result-card">
            <div className="result-card__container">
                <Details data={data} extract={extract} className="result-card__details" />
            </div>
        </div>
    );
};
